export const LOAD_CROP = 'load'
export const SAVE_CROP = 'save'

export const TRASH_CROP = 'trash'
export const UNTRASH_CROP = 'untrash'
export const DELETE_CROP = 'delete'
